import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../../http_requests_on_errors';
import {
    CREATE_BASELINE,
    CREATE_BASELINE_SESSION,
    DELETE_BASELINE_SESSION,
    EDIT_BASELINE,
    EDIT_BASELINE_SESSION,
    GET_BASELINES,
    GET_BASELINES_SUCCESS,
} from './baseline.types';
import { authService } from './baseline.service';

/** Baselines */

function* getBaselines({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    try {
        const res = yield call(authService.getBaselinesService, payload?.params);
        yield put({
            type: GET_BASELINES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* createBaseline({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.createBaselineService, payload?.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}
function* createBaselineSession({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.createBaselineSessionService, payload?.baselineId, payload?.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editBaseline({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editBaselineService, payload?.id, payload?.body);
        // const res = yield call(authService.getBaselinesService, payload?.params);
        // yield put({
        //     type: GET_BASELINES_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editBaselineSession({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editBaselineSessionService, payload?.baselineId, payload?.sessionId, payload?.body);
        // const res = yield call(authService.getBaselinesService, payload?.params);
        // yield put({
        //     type: GET_BASELINES_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteBaselineSession({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.deleteBaselineSessionService, payload?.baselineId, payload?.sessionId);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

export const watchBaselines = function* watchBaselinesAuth() {
    /** Baselines  */
    yield takeLatest(GET_BASELINES, getBaselines);
    yield takeLatest(CREATE_BASELINE, createBaseline);
    yield takeLatest(CREATE_BASELINE_SESSION, createBaselineSession);
    yield takeLatest(EDIT_BASELINE, editBaseline);
    yield takeLatest(EDIT_BASELINE_SESSION, editBaselineSession);
    yield takeLatest(DELETE_BASELINE_SESSION, deleteBaselineSession);
    /** End */
};
